import { render, staticRenderFns } from "./FacebookAdsTableRow.vue?vue&type=template&id=e117be3a&scoped=true&"
import script from "./FacebookAdsTableRow.vue?vue&type=script&lang=js&"
export * from "./FacebookAdsTableRow.vue?vue&type=script&lang=js&"
import style0 from "./FacebookAdsTableRow.vue?vue&type=style&index=0&id=e117be3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e117be3a",
  null
  
)

export default component.exports